import Path from './Path';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Hexagons(_ref) {
  let {
    id,
    height,
    fill,
    stroke,
    strokeWidth,
    strokeDasharray,
    shapeRendering,
    background,
    className,
    size = 3,
    gap = 0
  } = _ref;
  const hexWidth = size * Math.sqrt(3) + gap;
  const hexHeight = size * 2 + gap;
  const path = `
        M ${size * Math.sqrt(3) / 2 + gap / 2},${gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size / 2 + gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size * 1.5 + gap / 2}
        L ${size * Math.sqrt(3) / 2 + gap / 2},${size * 2 + gap / 2}
        L ${gap / 2},${size * 1.5 + gap / 2}
        L ${gap / 2},${size / 2 + gap / 2}
        Z
    `;
  return /*#__PURE__*/_jsx(Path, {
    path: path,
    id: id,
    width: hexWidth,
    height: hexHeight,
    fill: fill,
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeDasharray: strokeDasharray,
    shapeRendering: shapeRendering,
    background: background
  });
}